module.exports = __webpack_public_path__ + "img/hr-concrete-transitions.eec3bfd5.png";